<script>
import Multiselect from 'vue-multiselect'

export default {

    components: { Multiselect },

    props: {

    },

    data() {
        return {}
    },

    watch: {

    },

    computed: {

    },

    async mounted() {

    },

    methods: {

    }
}
</script>

<template>
    <div>
        <b-form-group
            label="Условие"
            label-for="event_wait_operation"
        >
            <b-form-textarea
                id="event_wait_operation"
                v-model="$parent.event_wait_params.operation"
                placeholder="$var1 == 'текст' || $var2 == 123"
                rows="4"
            ></b-form-textarea>
        </b-form-group>
    </div>
</template>
